<template>
  <a-drawer
    :title="$t('优惠券领取记录')"
    :width="1400"
    :visible="visible"
    @close="handleClose"
  >
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="14">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('领取人')" prop="userName">
                <a-input
                  v-model="queryParam.userName"
                  :maxLength="32"
                  :placeholder="$t('请输入')+$t('领取人')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('手机号')" prop="userMobile">
                <a-input
                  v-model="queryParam.userMobile"
                  :maxLength="32"
                  :placeholder="$t('请输入')+$t('手机号')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="status">
                <a-select v-model="queryParam.status" :placeholder="$t('请选择')" allow-clear>
                  <a-select-option :value="1">{{ $t('未使用') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('已使用') }}</a-select-option>
                  <a-select-option :value="3">{{ $t('已过期') }}</a-select-option>
                  <a-select-option :value="4">{{ $t('已作废') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('领取开始时间')" prop="receiveTimeBeginTime">
                <a-date-picker
                  v-model="queryParam.receiveTimeBeginTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                  style="width: 100%"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('领取结束时间')" prop="receiveTimeEndTime">
                <a-date-picker
                  v-model="queryParam.receiveTimeEndTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                  style="width: 100%"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('过期开始时间')" prop="expireTimeBeginTime">
                <a-date-picker
                  v-model="queryParam.expireTimeBeginTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                  style="width: 100%"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('过期结束时间')" prop="expireTimeEndTime">
                <a-date-picker
                  v-model="queryParam.expireTimeEndTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                  style="width: 100%"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('使用开始时间')" prop="useTimeBeginTime">
                <a-date-picker
                  v-model="queryParam.useTimeBeginTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                  style="width: 100%"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('使用结束时间')" prop="useTimeEndTime">
                <a-date-picker
                  v-model="queryParam.useTimeEndTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                  style="width: 100%"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons" style="float: right; overflow: hidden;">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />{{ $t('查询') }}
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />{{ $t('重置') }}
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%' }"
      >
        <span slot="couponType" slot-scope="text, record">
          <a-tag v-if="record.couponType === 1" color="blue">{{ $t('满减券') }}</a-tag>
          <a-tag v-else-if="record.couponType === 2" color="green">{{ $t('折扣券') }}</a-tag>
          <a-tag v-else-if="record.couponType === 3" color="orange">{{ $t('运费券') }}</a-tag>
        </span>
        <span slot="amount" slot-scope="text, record">
          <span v-if="record.couponType === 1">{{ record.amount }}</span>
          <span v-else-if="record.couponType === 2">{{ record.discountRate }}{{ $t('折') }}</span>
          <span v-else-if="record.couponType === 3">{{ record.amount }}</span>
        </span>
        <span slot="receiveTime" slot-scope="text, record">
          {{ parseTime(record.receiveTime) }}
        </span>
        <span slot="useTime" slot-scope="text, record">
          {{ parseTime(record.useTime) }}
        </span>
        <span slot="expireTime" slot-scope="text, record">
          {{ parseTime(record.expireTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 1" color="orange">{{ $t('未使用') }}</a-tag>
          <a-tag v-else-if="record.status === 2" color="green">{{ $t('已使用') }}</a-tag>
          <a-tag v-else-if="record.status === 3" color="red">{{ $t('已过期') }}</a-tag>
          <a-tag v-else-if="record.status === 4" color="gray">{{ $t('已作废') }}</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['coupon:couponuser:remove']">
            <a-icon type="delete" />{{ $t('删除') }}
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 底部按钮 -->
    <div class="drawer-footer">
      <a-button @click="handleClose">{{ $t('关闭') }}</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { pageCouponUser, delCouponUser } from '@/api/coupon/couponUser'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CouponUserDrawer',
  components: {
    CustomDictTag
  },
  mixins: [tableMixin],
  data() {
    return {
      visible: false,
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 优惠券ID
      couponId: undefined,
      // 查询参数
      queryParam: {
        id: undefined,
        couponId: undefined,
        couponName: undefined,
        userName: undefined,
        userMobile: undefined,
        userId: undefined,
        grantType: undefined,
        operatorId: undefined,
        receiveTime: undefined,
        expireTime: undefined,
        useTime: undefined,
        status: undefined,
        orderId: undefined,
        isLocked: undefined,
        expireTimeBeginTime: undefined,
        expireTimeEndTime: undefined,
        useTimeBeginTime: undefined,
        useTimeEndTime: undefined,
        receiveTimeBeginTime: undefined,
        receiveTimeEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('优惠券名称'),
          dataIndex: 'couponName',
          ellipsis: true,
          align: 'center',
          width: 150
        },
        {
          title: this.$t('优惠券类型'),
          dataIndex: 'couponType',
          scopedSlots: { customRender: 'couponType' },
          align: 'center',
          width: 120
        },
        {
          title: this.$t('面额'),
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
          ellipsis: true,
          align: 'center',
          width: 100
        },
        {
          title: this.$t('满多少元使用'),
          dataIndex: 'thresholdAmount',
          ellipsis: true,
          align: 'center',
          width: 120
        },
        {
          title: this.$t('领取人姓名'),
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center',
          width: 120
        },
        {
          title: this.$t('领取人手机号'),
          dataIndex: 'userMobile',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('领取时间'),
          dataIndex: 'receiveTime',
          width: 180,
          scopedSlots: { customRender: 'receiveTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('使用时间'),
          dataIndex: 'useTime',
          width: 180,
          scopedSlots: { customRender: 'useTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('过期时间'),
          dataIndex: 'expireTime',
          width: 180,
          scopedSlots: { customRender: 'expireTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center',
          width: 100
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 120,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    moment,
    // 打开抽屉
    open(couponId) {
      this.couponId = couponId
      this.visible = true
      this.resetQuery()
      this.handleQuery()
    },
    // 关闭抽屉
    handleClose() {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
      this.ids = []
    },
    getTotal(total) {
      return `${this.$t('共')} ${total} ${this.$t('条')}`
    },
    /** 查询用户领券/发放记录列表 */
    getList() {
      this.loading = true
      this.queryParam.couponId = this.couponId
      pageCouponUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        couponId: this.couponId,
        couponName: undefined,
        userName: undefined,
        userMobile: undefined,
        userId: undefined,
        grantType: undefined,
        operatorId: undefined,
        receiveTime: undefined,
        expireTime: undefined,
        useTime: undefined,
        status: undefined,
        orderId: undefined,
        isLocked: undefined,
        expireTimeBeginTime: undefined,
        expireTimeEndTime: undefined,
        useTimeBeginTime: undefined,
        useTimeEndTime: undefined,
        receiveTimeBeginTime: undefined,
        receiveTimeEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据?'),
        content: `${this.$t('当前选中编号为')} ${ids} ${this.$t('的数据')}`,
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delCouponUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('删除成功'), 3)
            })
        },
        onCancel() {
          that.ids = []
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>
